import * as React from "react";

import { useWindowEventListener } from "../DOM/UseWindowEventListener";

import {
    isKeyboardCombinationPressed,
    KeyboardCombinationString,
    parseKeyboardCombination,
} from "./KeyboardCombinationParser";

export function useKeyboardShortcut(
    shortcut: KeyboardCombinationString,
    handler: () => void,
    useKeyDown: boolean = false
): void {
    const keyboardCombination = React.useMemo(() => parseKeyboardCombination(shortcut), [shortcut]);
    const callback = React.useCallback(
        (e: KeyboardEvent): void => {
            if (isKeyboardCombinationPressed(e, keyboardCombination)) {
                handler();
            }
        },
        [keyboardCombination, handler]
    );
    useWindowEventListener(useKeyDown ? "keydown" : "keyup", callback);
}
